<template>
<div>
    <div
        style="position: relative"
    >
        <span :style="$rc.styleInputLabel()">{{label}}</span>
        <ul>
            <li
                v-for="(item, index) in value"
                :key="'mp_'+index"
                v-html="$rc.wrapHTML(item)"
                style="margin-bottom: 15px"
            >
                
            </li>
        </ul>

        <div
            style="position: absolute; top: 0px; right: 0px"
            v-if="!disabled"
        >
            <v-tooltip
                v-if="default_value != null && default_value.length > 0"
                bottom
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        color="secondary"
                        v-bind="attrs"
                        v-on="{ ...on, click: onClickReturnToDefault }"
                        style="margin-right: 5px;"
                    >
                        mdi-restore
                    </v-icon>
                </template>
                <span>Return to default</span>
            </v-tooltip>
            <v-icon
                color="primary"
                v-on:click="showDialog()"
            >
                mdi-lead-pencil
            </v-icon>
        </div>
    </div>

    <v-dialog
        v-model="dialog"
        max-width="1200"
        fullscreen
    >
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>{{label}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onCancel"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onOk"
                >
                    Save &amp; Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card>

            <v-card-text>
                <br/>
                <m-edit-message-patterns
                    v-model="dialog_value"
                    :context="context"
                    :always_mms="always_mms"
                    :bulk_message_id="bulk_message_id"
                    :trigger_save="save_requested"
                    v-on:example-message-changed="onExampleMessageChanged"
                    v-on:save-requested="onSaveRequested"
                    v-on:save-triggered="onSaveTriggered"
                />
            </v-card-text>

        </v-card>
    </v-dialog>
</div>
</template>

<script>
const _ = require('lodash');

export default {

    props: {
        label: {
            type: String,
            default: function() { return 'Message Patterns'; }, 
        },

        context: {
            type: String,
            default: function() { return 'manually-sent'; }
        },

        value: {
            type: Array,
            default: function() { return []; }
        },

        always_mms: {
            type: Boolean,
            default: function() { return false; }
        },

        disabled: {
            type: Boolean,
            default: function() { return false; }
        },

        bulk_message_id: {
            type: String,
            default: function() { return null; }
        },

        default_value: {
            type: Array,
            default: function() { return null; }
        }
    },

    data() {
        return {
            dialog: false,
            dialog_value: [],
            save_requested: false,
        }
    },

    methods: {

        showDialog()
        {
            let initial_value = _.cloneDeep(this.value);

            if ( this.default_value != null && initial_value.length == 0 )
            {
                initial_value = _.cloneDeep(this.default_value);
            }

            this.dialog_value = initial_value;
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        onOk()
        {
            // Trigger save via event-driven flow; child will check for shortened links
            this.save_requested = true;
        },

        onSaveRequested()
        {
            this.$emit('input', this.dialog_value);
            this.dialog = false;
            this.$router.dialog_guard = null;
            this.save_requested = false;
        },

        onSaveTriggered()
        {
            // Reset the trigger so it can be used again
            this.save_requested = false;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                next();
                return;
            }

            // Trigger save request and intercept navigation until save completes
            this.save_requested = true;
            next(false);
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickReturnToDefault()
        {
            this.$rc.confirm({
                'title': 'Return to Default',
                'body': 'Are you sure you want to return to the default message patterns? Your current customizations will be lost.',
                'btn_text_ok': 'Return to Default',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doReturnToDefault();
                },
            });
        },

        doReturnToDefault()
        {
            if (this.default_value != null && this.default_value.length > 0)
            {
                this.$emit('input', _.cloneDeep(this.default_value));
            }
        },

        onExampleMessageChanged(example_message)
        {
            // Forward the event from the inner message patterns component
            this.$emit('example-message-changed', example_message);
        },

    },
}
</script>

<style lang="scss" scoped>
ul li {
    padding-top: .25rem;
    list-style: none;
}
</style>